<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn color="primary" link to="/cadastro-oferta">
        <v-icon left>mdi-plus</v-icon>
        Oferta
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma oferta" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
      <px-ofertas-header-filter @change="change"/>
    </v-row>
    <v-row dense v-if="hasFilters" class="mt-1">
      <px-ofertas-filtros-selecionados @change="change"/>
      <v-spacer/>
      <v-btn color="primary" text small @click="limparFiltros">
        Limpar filtros
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OfertasHeaderFilter from './OfertasHeaderFilter.vue';
import { CLEAR_FILTERS_ACTION } from '../../store/listagem-ofertas/actions.type';
import OfertasFiltrosSelecionados from './OfertasFiltrosSelecionados.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemOfertas', ['stringFilter', 'hasFilters']),
    searchText: {
      get() {
        return this.$store.getters['listagemOfertas/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemOfertas/searchText', searchText);
      },
    },
  },
  methods: {
    ...mapActions('listagemOfertas', {
      clearFilters: CLEAR_FILTERS_ACTION,
    }),
    limparFiltros() {
      this.clearFilters();
      this.onChangeFilter(this.stringFilter);
    },
    change() {
      this.onChangeFilter(this.stringFilter);
    },
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
  components: {
    pxOfertasHeaderFilter: OfertasHeaderFilter,
    pxOfertasFiltrosSelecionados: OfertasFiltrosSelecionados,
  },
};
</script>
